import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { PagePrebidStackSliceDTO } from './types'

export const PAGE_PREBID_STACK_FRAGMENT: TypedDocumentNode<PagePrebidStackSliceDTO> = gql`
  fragment PagePrebidStackFragment on PagePrebidStack {
    id
    customPrebidTimeoutEnabled
    prebidTimeout
  }
`
